$('.supplier-learn-more').on("click", "button" ,function(event){
    $('body').addClass('slide-out-active');
    $('.supplier-page-modal-container').addClass('active');
});

function closeModal(targetEvent) {
    $(targetEvent).closest('.supplier-page-modal-container').toggleClass('closing');
    $('body').removeClass('slide-out-active');
    $('.supplier-page-modal-container.active').removeClass('active');
}

$('body').on('click', ".modal-close", (event) => {
    closeModal(event.target);
});

$('body').on('click', ".supplier-page-modal-container", (event) => {
    if (!$(event.target).is('.supplier-page-modal') && !$(event.target).closest('.supplier-page-modal').length) {
      $(event.target).closest('.supplier-page-modal-container').toggleClass('closing');
        $('body').removeClass('slide-out-active');
        $('.supplier-page-modal-container.active').removeClass('active');
    }
});

// section rendering API

function handleResponse() {
  let section_html = this.responseText;

  let $productTray = $('.supplier-page-collection-container');
  $productTray.append(section_html);
}

const request = new XMLHttpRequest();
let $productTray = $('.supplier-page-collection-container');
let collection_url = $productTray.attr('data-collection-url');
let request_url = `${collection_url}?section_id=main-collection-product-grid`

request.addEventListener('load', handleResponse);
request.open('GET', request_url, true);
request.send();